module.exports = __webpack_public_path__ + "media/image-not-found-1280.png";


//////////////////
// WEBPACK FOOTER
// ../assets/media/editor/image-not-found-1280.png
// module id = 3553
// module chunks = 0